import { useParams, Link } from 'react-router-dom';
import { UPCOMING_EVENTS } from '@/data/content';
import Breadcrumb from '@/components/ui/Breadcrumb';

const allEvents = [
  ...UPCOMING_EVENTS,
  { date: '2026-06-20', name: '2026 春季赛季总决赛', location: '上海', status: 'closed' as const },
  { date: '2026-05-10', name: '华东区校园联赛', location: '杭州', status: 'closed' as const },
  { date: '2025-12-15', name: '2025 全国总决赛', location: '深圳', status: 'closed' as const },
];

export default function EventDetailPage() {
  const { eventId } = useParams<{ eventId: string }>();
  const idx = parseInt(eventId || '0');
  const event = allEvents[idx] || allEvents[0];

  const statusMap: Record<string, { label: string; className: string }> = {
    upcoming: { label: '即将开放', className: 'bg-border-dark text-text-secondary' },
    open: { label: '报名中', className: 'bg-arena-green/20 text-arena-green' },
    closed: { label: '已结束', className: 'bg-text-disabled/10 text-text-disabled' },
  };
  const s = statusMap[event.status];

  return (
    <div className="max-w-4xl mx-auto px-6 pt-8 pb-16">
      <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '活动', href: '/events' }, { label: event.name }]} />

      <div className="flex items-center gap-4 mb-2">
        <span className="text-sm font-mono text-arena-gold">{event.date}</span>
        <span className={`text-[10px] px-2 py-0.5 rounded-tag ${s.className}`}>{s.label}</span>
      </div>
      <h1 className="text-2xl font-extrabold text-text-primary mb-2">{event.name}</h1>
      <p className="text-text-secondary text-sm mb-8">{event.location}</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
        {[
          { t: '赛事信息', items: ['组别：少年组 / 青少组 / 菁英组 / 极客组', '赛制：三局两胜淘汰制', '场地方案：方案3 全规格场地', '团队赛：同步开放 2v2'] },
          { t: '报名须知', items: ['报名截止：赛前 7 天', '检录时间：赛前 1 小时', '车辆须通过称重+通规检查', '主板须与裁判系统自动握手'] },
          { t: '奖项设置', items: ['冠军 / 亚军 / 季军', '最佳改装奖', '最猛碰撞奖', '本赛季积分计入全国排名'] },
        ].map((sec) => (
          <div key={sec.t} className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-5">
            <h2 className="text-sm font-extrabold text-text-primary mb-4">{sec.t}</h2>
            <ul className="space-y-2">{sec.items.map((item) => (<li key={item} className="flex items-start gap-2 text-xs text-text-secondary"><span className="w-1 h-1 rounded-full bg-arena-blue/60 mt-1.5 shrink-0" />{item}</li>))}</ul>
          </div>
        ))}
      </div>

      <div className="flex gap-3 mb-10">
        {event.status === 'open' && <button className="px-8 h-10 rounded-btn bg-arena-red text-white text-sm font-bold hover:brightness-110 transition-all">立即报名</button>}
        <Link to="/events" className="px-5 h-10 rounded-btn border border-arena-blue text-arena-blue text-sm font-bold hover:bg-arena-blue/10 transition-all inline-flex items-center">返回活动列表</Link>
      </div>

      <div className="border-t border-border-dark pt-8">
        <h2 className="text-lg font-extrabold text-text-primary mb-4">其他赛事</h2>
        <div className="space-y-2">
          {allEvents.filter((_, i) => i !== idx).slice(0, 3).map((e, i) => (
            <Link key={i} to={`/events/${allEvents.indexOf(e)}`} className="flex items-center gap-3 p-3 bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt hover:border-arena-blue/40 transition-all">
              <span className="text-xs font-mono text-arena-gold w-20">{e.date}</span>
              <span className="text-sm text-text-secondary flex-1">{e.name}</span>
              <span className="text-xs text-text-disabled">{e.location}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
